import React, { useEffect, useRef } from 'react';
import { SUMMARY_TOOLTIP } from '../../constants/constants';

const SummaryToolTip = (props) => {
    const ref = useRef(null);
    
    useEffect(() => {
        const handleClickOutside = (e) => {
            if(e.target.closest('.ctrl-icons') == null){
                props.setShowSummaryToolTip(false);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    });

    if(!props.showSummaryToolTip)
        return null;

    return (<div className="summary-tooltip-wrapper">
        <div className="close-wrap"
            onClick={() => {
                props.setShowSummaryToolTip(false);
            }}>
            <span className="close">
                <i className="icon-cross-icon"></i>
            </span>
        </div>
        <div className="tips" dangerouslySetInnerHTML={{ __html: SUMMARY_TOOLTIP }}>
        </div>
    </div>);
}

export default SummaryToolTip;